
export const sFechaPublicacion = '2024-03-05T10:57:22.7996937-06:00';
export const sVersion = 'var0.1.03051057';
            